import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { notifyPromise } from "../../../Utils/Helper";
import { deleteUserSuccess, deleteUserFailure } from "../../Action/auth/deleteUserAction";
import { DELETE_USER } from "../../Action/actionTypes";

function* deleteUserRequest(action) {
  try {


    const { id } = action.payload;
    const { data } = yield notifyPromise(API.put(`/delete-user?id=${id}`));
    
    if (action?.payload?.callback) {
      yield call(action.payload.callback, data);
    }

    if (data?.meta?.code === 200) {
      yield put(deleteUserSuccess(data?.data));
    } else {
      yield put(deleteUserFailure());
    }
  } catch (error) {
    if (action?.payload?.callback) {
      yield call(action.payload.callback, {});
    }
    yield put(deleteUserFailure());
  }
}

export function* watchDeleteUser() {
  yield takeEvery(DELETE_USER, deleteUserRequest);
}

export default function* rootSaga() {
  yield all([watchDeleteUser()]);
}
